import FaqPage from "~/components/Faq/FaqPage";

const ForSellers = () => {
  return (
    <FaqPage
      selected={"for-sellers"}
      description={
        "A list of Frequently Asked Questions (FAQs) from our sellers to support their use of RealEstateAgents.com."
      }
    />
  );
};

export default ForSellers;
